import React, { useState } from "react";

export default function ToggleButtonComp({
  defaultValue,
  setToggleValue,
  toggledValue,
  toggleButtonCompTitle,
  id, // Unique ID for each toggle
}) {
  const [isToggled, setIsToggled] = useState(false);

  const handleToggle = () => {
    const newToggleState = !isToggled;
    setIsToggled(newToggleState);
    if (setToggleValue) {
      setToggleValue(newToggleState);
    }
  };

  return (
    <div className="flex items-center w-full gap-2 my-1 justify-start">
      <div className="flex items-center gap-2">
        <input
          type="checkbox" // Correct input type
          id={id} // Unique ID for accessibility
          className="sr-only"
          checked={toggledValue || isToggled}
          onChange={handleToggle}
        />
        <label
          htmlFor={id}
          className={`relative w-[36px] h-[18px] flex items-center cursor-pointer border-[0px] border-gray-100 rounded-full ${
            isToggled ? "bg-[#5AC189]" : "bg-[#f85353]"
          }`}
        >
          <div className="rounded-full shadow-inner flex items-center text-white font-bold text-[8px] pl-[3px]">
            ON
          </div>
          <div className="rounded-full shadow-inner text-[8px] flex items-center text-white font-bold relative left-[3px]">
            OFF
          </div>
          <div
            className={`z-5 rounded-full absolute w-[16px] h-[16px] transition-transform duration-300 ${
              isToggled
                ? "bg-white transform translate-x-[120%]"
                : "bg-white transform translate-x-[6%]"
            }`}
          ></div>
        </label>
      </div>
      <label htmlFor={id} className="font-light">
        {toggleButtonCompTitle}
      </label>
    </div>
  );
}
